export const PLAIN_BUTTON_THEME = {
  pddng: {
    v: {
      s: '2px',
      m: '4px',
      l: '6px',
    },
    h: {
      s: '4px',
      m: '6px',
      l: '8px',
    },
    icon: {
      s: '4px',
      m: '4px',
      l: '4px',
    },
  },
  gap: {
    sm: '2px',
    md: '4px',
    lg: '4px',
  },
  radius: {
    sm: '8px',
    md: '8px',
    lg: '8px',
  },
  standaloneIconSize: {
    sm: 16,
    md: 20,
    lg: 24,
  },
  withLabelIconSize: {
    sm: 16,
    md: 16,
    lg: 20,
  },
};